import { Component, Input, OnInit } from '@angular/core';

import { CBMError } from 'app/models';

@Component({
  selector: 'message-box',
  templateUrl: './messagebox.component.html',
  styleUrls: ['./messagebox.component.scss']
})
export class MessageboxComponent implements OnInit {
  @Input() messages: CBMError[];

  constructor() {}

  ngOnInit() {
    this.messages = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/messagebox/messagebox.component.ts